import { Button } from '@mantine/core'

export function GameButton({ children, selected, ...props }) {
  return (
    <Button
      variant={selected ? 'filled' : 'light'}
      color="cyan"
      styles={{
        root: {
          border: selected
            ? '1px solid var(--mantine-color-cyan-5)'
            : '1px solid rgba(0, 255, 255, 0.2)',
          transition: 'all 0.2s ease',
          fontFamily: 'Rajdhani, sans-serif',
          fontWeight: 600,
          fontSize: '0.95rem',
          '&:hover': {
            borderColor: 'var(--mantine-color-cyan-4)',
            boxShadow: '0 0 12px rgba(0, 255, 255, 0.3)',
          },
        },
      }}
      {...props}
    >
      {children}
    </Button>
  )
}
